import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListFeedbackStart,
  getListFeedbackSuccess,
  getListFeedbackFailed,
} from "../redux/getListFeedback";
import { getListFeedbackAPI } from "core/http/service/decleareLeave";
import moment from "moment";

function* getListFeedbackWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getListFeedbackAPI, {
      screenCode,
      ...payload,
    });
    const formattedData = res.data.map((item, index) => ({
      ...item,
      index: index + 1,
      fromDate: moment(item?.fromDate),
      toDate: moment(item?.toDate),
    }));
    yield put({
      type: getListFeedbackSuccess.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListFeedbackFailed.type,
    });
  }
}

function* watchGetListFeedback() {
  yield takeLatest(getListFeedbackStart.type, getListFeedbackWork);
}

export default function* getListFeedbackSaga() {
  yield all([watchGetListFeedback()]);
}
